/** @format */

import React, { useState, useEffect } from 'react';
import { PageContainer, InputV2, ButtonLoading, Icons } from 'components';
import { useNavigate } from 'react-router-dom';
import createToast from 'components/Toast/Toast';
import { Button, Typography, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Services from '../services';
import { FileBoxItem, UploadFileDg } from './components';
import { constBreadCrumbsTitle } from 'utility';
const Bills = () => {
  //* * States */
  const [submitting, setSubmitting] = useState(false);
  const [description, setDescription] = useState('');
  const [selectedDocType, setSelectedDocType] = useState('NATIONAL_CARD_IMAGE');
  const [isOpenUploadDg, setIsOpenUploadDg] = useState(false);
  const [typeDg, setTypeDg] = useState('');
  const [level, setLevel] = useState(null);
  const [data, setData] = useState([
    {
      label: 'تصویر کارت ملی',
      level: 0,
      type: 'NATIONAL_CARD_IMAGE',
      content: {
        fileUploaded: [],
      },
    },

    {
      label: 'آگهی تاسیس',
      level: 1,
      type: 'FOUNDED_AD',
      content: {
        fileUploaded: [],
      },
    },

    {
      label: 'روزنامه رسمی',
      level: 2,
      type: 'OFFICIAL_NEWSPAPER',
      content: {
        fileUploaded: [],
      },
    },

    {
      label: 'اساس نامه',
      level: 3,
      type: 'STATUTE',
      content: {
        fileUploaded: [],
      },
    },

    {
      label: 'نامه درخواست افتتاح حساب دیجیتال',
      level: 4,
      type: 'LETTER',
      content: {
        fileUploaded: [],
      },
    },
    {
      label: 'جواز کسب',
      level: 5,
      type: 'BUSINESS_LICENSE',
      content: {
        fileUploaded: [],
      },
    },

    {
      label: 'سایر مدارک',
      level: 6,
      type: 'OTHER',
      content: {
        fileUploaded: [],
      },
    },
  ]);
  //* * Hooks */
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {}, [selectedDocType]);
  useEffect(() => {
    let isMounted = true; // note this flag denote mount status
    if (isMounted) {
    }
    return () => {
      isMounted = false;
    };
  }, []);

  //* * Api Requests */
  const submitForm = async (e) => {
    e.preventDefault();
    const regex = /<[^>]*>/g;

    if (regex.test(description)) {
      createToast('خطا', 'نمیتوانید در متن از تگ html استفاده کنید', 'danger');

      return;
    }


    // Data
    const data = {
      description,
      name: getFileNames(),
      url: getFileUrls(),
    };

    // Req
    try {
      setSubmitting(true);
      await Services.postRequest(data);

      createToast('موفق', 'درخواست جدید با موفقیت ثبت شد!', 'success');

      navigate('/RequestConfirmation');
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };

  //* * Other Functions */
  const getFileUrls = () => {
    let hashList = [];
    for (let i = 0; i < data.length; i++) {
      const dataElement = data[i];
      const hash = dataElement.content.fileUploaded.map((item) => {
        return item['hash'];
      });
      hashList.push(...hash);
    }
    return hashList?.map((f) => `https://podspace.pod.ir/api/files/${f}`) ?? [];
  };
  const getFileNames = () => {
    let names = [];
    for (let i = 0; i < data.length; i++) {
      const dataElement = data[i];
      if (dataElement.level !== 6) {
        for (let j = 0; j < dataElement.content.fileUploaded.length; j++) {
          const element = dataElement.content.fileUploaded[j];
          if (
            dataElement.content.fileUploaded.length &&
            dataElement.content.fileUploaded.length === 1
          ) {
            names.push(dataElement.label);
          } else {
            names.push(dataElement.label + `(${j + 1})`);
          }
        }
      } else {
        // از نوع سایر مدارک هست
        for (let j = 0; j < dataElement.content.fileUploaded.length; j++) {
          const element = dataElement.content.fileUploaded[j];
          if (dataElement.content.fileUploaded.length > 0) {
            names.push(element?.fileOtherName);
          }
        }
      }
    }
    return names;
  };

  const onOpenUploadDialog = (level, type) => {
    setTypeDg(type);
    setLevel(level);
    setIsOpenUploadDg(true);
  };

  const onChangeUpload = (files) => {
    let c = JSON.stringify(data);
    let copyData = [];
    copyData = [...JSON.parse(c)];
    if (Array.isArray(copyData)) {
      var obj = copyData[level];

      setTimeout(() => {
        copyData[level].content.fileUploaded = [...files];
        setData(copyData);
      }, 10);
    }
  };
  const hint =
    'در این بخش می‌توانید درخواست جدیدی برای احراز هویت کسب‌وکار به همراه مدارک ارسال کنید.';

  return (
    <PageContainer
      title="درخواست جدید"
      pageKey="requestConfirmation"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.NEW_REQUEST_CONFIRMATION}
      meta={
        <Button
          onClick={() => navigate(-1)}
          color="primary"
          endIcon={<Icons icon="CaretLeft" color="#2b3990" size="23" />}
          variant="outlined"
        >
          بازگشت
        </Button>
      }
    >
      <Grid container direction="column" spacing={3}>
        <Grid
          direction="row"
          spacing={3}
          container
          item
          xs={12}
          className={classes.formSection}
        >
          {data.map(
            (v) =>
              (v.level !== 6 || (v.level === 6 && data[6]?.content?.fileUploaded.length > 0)) && (
                <Grid item md={6} xs={12} key={v.type}>
                  <FileBoxItem data={v} onOpenUploadDialog={onOpenUploadDialog} />
                </Grid>
              ),
          )}
          {!data[6]?.content?.fileUploaded.length && (
            <Grid
              item
              md={6}
              xs={12}
              style={{
                color: '#2B398E',
                fontSize: '12px',
                display: 'flex',
                alignItems: 'center',
                marginRight: '12px',
              }}
            >
              <span style={{ marginLeft: '4px' }}>
                <Icons icon="plusCircle" color="#2B398E" size="18" />
              </span>

              <span
                className={classes.notRequredTitle}
                onClick={() => {
                  onOpenUploadDialog(6, 'ADD');
                }}
              >
                {' '}
                بارگذاری سایر مدارک (اختیاری)
              </span>
            </Grid>
          )}
        </Grid>

        <Grid
          item
          spacing={3}
          xs={12}
          className={classes.formSection}
          style={{ marginTop: 12, padding: 16, paddingLeft: '54px' }}
        >
          <Typography className={classes.titleText}>
            توضیحات درخواست
          </Typography>
          <InputV2
            name="fileName"
            rows={5}
            forceValue={description}
            inputProps={{ style: { minHeight: 75 } }}
            placeholder="متن درخواست مورد نظر ..."
            multiline
            fullWidth
            onChangeValue={(e) => setDescription(e?.target?.value)}
          />
        </Grid>

        <Grid
          container
          spacing={2}
          xs={12}
          style={{ marginBottom: 8, paddingLeft: 10 }}
          justifyContent="flex-end"
        >
          {true && (
            <ButtonLoading
              onClick={submitForm}
              className={classes.submitButton}
              color="primary"
              variant="contained"
              loading={submitting}
              name="ارسال درخواست"
              disabled={
                !data[4].content.fileUploaded.length ||
                submitting
              }
            />
          )}
        </Grid>
      </Grid>

      <UploadFileDg
        isOpenDg={isOpenUploadDg}
        setIsOpenDg={setIsOpenUploadDg}
        level={level}
        typeDg={typeDg}
        data={data}
        setData={setData}
        onChangeUpload={onChangeUpload}
      />
    </PageContainer>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {},
  formSection: {
    [theme.breakpoints.up('md')]: {
      alignSelf: 'flex-start',
      flexBasis: '50%',
      maxWidth: '50%',
      width: '50%',
    },
  },
  title: {
    color: theme.palette.gray[5],
  },
  titleBox: {
    marginLeft: '8px',
    fontSize: '12px',
  },
  chipBlock: {
    maxWidth: '460px',
    width: '460px',
    padding: '10px 0 0 !important',
    textAlign: 'center',
    '@media(max-width: 600px)': {
      maxWidth: '100%',
    },
  },
  notRequredTitle: {
    cursor: 'pointer',
    fontSize: '13px',
  },
  chips: {
    marginBottom: 8,
    width: '100%',
    height: '80px',
    display: 'inline-flex',
    justifyContent: ' space-between',
    backgroundColor: '#fff',
    borderRadius: ' 6px',
    border: '2px solid #E2E5E9',
    padding: '0 10px',

    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    '&:focus': {
      backgroundColor: '#fff',
    },
    '&:hover': {
      backgroundColor: '#fff',
    },
    '& .MuiChip-label': {
      display: 'flex',
      gap: '10px',
    },
    '& .MuiInputLabel': {
      width: '88%',
      paddingLeft: 0,
      fontSize: 12,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      display: 'flex',
      gap: '10px',
    },
    '& .MuiTypography-root': {
      fontSize: 12,
      textAlign: 'left',
      fontWeight: '500 !important',
      margin: '5px 0',
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column',
      justifyContent: 'center',
      '& .volume': {
        fontSize: 11,
        color: '#9AA6B1',
        fontWeight: '100 !important',
      },
    },
  },
  titleIcon: {
    fontSize: 18,
    marginInlineStart: theme.spacing(2),
  },
  download: {
    color: '#fff',
    background: '#0D1C6A',
    cursor: 'pointer',
    display: 'inline-block',
    padding: ' 4px 12px ',
    fontSize: '12px',
    borderRadius: '20px',
    margin: '3px 10px 0',
  },
  titleText: {
    fontSize: 13,
    marginInlineStart: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
    //fontWeight: 'bold',
  },
  docItemsContainer: {
    marginTop: theme.spacing(1),
  },
  stepperAction: {
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  submitButton: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  containerSub: {
    display: 'flex',
    justifyContent: 'flex-start',
    margin: '4px',
  },

  btnEvent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '16px',
    borderTop: '1px solid #e0e0e0',
    paddingTop: '16px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  btnChangeStep: {
    marginBottom: 16,
    display: 'flex',
  },
  chipBlock: {
    marginTop: 15,
    padding: '0 20px 0 10px',
  },
  fileType: {
    width: '36px',
    position: 'relative',
    top: '5px',
  },
  chip: {
    marginBottom: 8,
    marginInlineEnd: 5,
    width: '49%',
    display: 'inline-flex',
    justifyContent: ' space-between',
    backgroundColor: theme.palette.primary.lighter,
    gap: '15px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.light,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
    '&.MuiInputLabel': {
      // clipPath: 'content-box',
      width: '88%',
    },
  },
}));

export default Bills;
